export default function Dashboard() {
  return (
    <section className="h-[150vh] w-full">
      <h1 className="text-4xl font-bold">Dashboard</h1>
    </section>
  );
}
